import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { HelperService } from '../../auxiliares/servicios/helper.service';

@Component({
  selector: 'app-snow-overlay',
  standalone: true,
  imports: [],
  templateUrl: './snow-overlay.component.html',
  styleUrls: ['./snow-overlay.component.scss'],
})
export class SnowOverlayComponent implements OnInit, OnDestroy {
  private helper = inject(HelperService);

  mostrarNieve = false;
  coposDeNieve: {
    left: number;
    delay: number;
    duration: number;
    size: number;
  }[] = [];
  private readonly cantidadCopos = 32;

  ngOnInit(): void {
    this.mostrarNieve = this.helper.esNavidad();

    if (this.mostrarNieve) {
      this.generarCopos();
    }
  }

  ngOnDestroy(): void {
    this.coposDeNieve = [];
  }

  private generarCopos(): void {
    for (let i = 0; i < this.cantidadCopos; i++) {
      this.coposDeNieve.push({
        left: Math.random() * 100, // Posición horizontal aleatoria (%)
        delay: Math.random() * 15, // Delay de inicio (segundos)
        duration: 10 + Math.random() * 10, // Duración de caída (10-20s)
        size: 12 + Math.random() * 8, // Tamaño del copo (12-20px)
      });
    }
  }
}
